// import { useState, useMemo } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { ArrowLeft } from "lucide-react";
// import quotationsData from "../data/quotationsData";
// import StatusStepper from "../components/modules/quotations/StatusStepper";
// import VendorQuoteCard from "../components/modules/quotations/VendorQuoteCard";

// function money(n) {
//   return `₹${n.toLocaleString("en-IN")}`;
// }

// const filterOptions = ["All", "Lowest Price", "Fastest Delivery", "Best Rated", "Verified only"];

// export default function QuotationDetail() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [filter, setFilter] = useState("All");
//   const [comparing, setComparing] = useState([]);

//   const enquiry = quotationsData.find((q) => q.id === id);

//   const highlights = useMemo(() => {
//     if (!enquiry || enquiry.quotes.length === 0) return null;
//     const bestPrice = [...enquiry.quotes].sort((a, b) => a.total - b.total)[0];
//     const fastest = [...enquiry.quotes].sort((a, b) => a.delivery - b.delivery)[0];
//     const bestMatch = [...enquiry.quotes].sort((a, b) => b.rating - a.rating)[0];
//     return { bestPrice, fastest, bestMatch };
//   }, [enquiry]);

//   const filteredQuotes = useMemo(() => {
//     if (!enquiry) return [];
//     const quotes = [...enquiry.quotes];
//     switch (filter) {
//       case "Lowest Price":
//         return quotes.sort((a, b) => a.total - b.total);
//       case "Fastest Delivery":
//         return quotes.sort((a, b) => a.delivery - b.delivery);
//       case "Best Rated":
//         return quotes.sort((a, b) => b.rating - a.rating);
//       case "Verified only":
//         return quotes.filter((q) => q.verified);
//       default:
//         return quotes;
//     }
//   }, [enquiry, filter]);

//   const badgesFor = (quote) => {
//     if (!highlights) return [];
//     const badges = [];
//     if (quote.id === highlights.bestPrice.id) badges.push("Best Price");
//     if (quote.id === highlights.fastest.id) badges.push("Fastest Delivery");
//     if (quote.id === highlights.bestMatch.id) badges.push("Best Overall Match");
//     return badges;
//   };

//   const toggleCompare = (quoteId) => {
//     setComparing((prev) =>
//       prev.includes(quoteId) ? prev.filter((id) => id !== quoteId) : [...prev, quoteId]
//     );
//   };

//   if (!enquiry) {
//     return (
//       <div className="h-40 flex items-center justify-center text-gray-400">
//         Enquiry not found.
//       </div>
//     );
//   }

//   return (
//     <div>
//       <button
//         type="button"
//         onClick={() => navigate("/dashboard/quotations")}
//         className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-4"
//       >
//         <ArrowLeft className="w-4 h-4" />
//         Back
//       </button>

//       <h1 className="text-3xl font-extrabold text-gray-900">{enquiry.title}</h1>
//       <p className="text-gray-500 mt-1 mb-5">
//         {enquiry.id} · {enquiry.quotes.length} quotations received
//       </p>

//       {/* Spec chips */}
//       <div className="flex flex-wrap gap-2 mb-6">
//         <span className="text-xs font-medium px-3 py-1.5 rounded-full bg-gray-100 text-gray-600">
//           {enquiry.category}
//         </span>
//         <span className="text-xs font-medium px-3 py-1.5 rounded-full bg-gray-100 text-gray-600">
//           {enquiry.industry}
//         </span>
//         <span className="text-xs font-medium px-3 py-1.5 rounded-full bg-gray-100 text-gray-600">
//           Qty {enquiry.qty}
//         </span>
//         <span className="text-xs font-medium px-3 py-1.5 rounded-full bg-gray-100 text-gray-600">
//           {money(enquiry.budgetMin)} – {money(enquiry.budgetMax)}
//         </span>
//         <span className="text-xs font-medium px-3 py-1.5 rounded-full bg-gray-100 text-gray-600">
//           Target {enquiry.targetDate}
//         </span>
//       </div>

//       <StatusStepper status={enquiry.status} />

//       {highlights && (
//         <div className="grid sm:grid-cols-3 gap-4 mb-6">
//           <div className="bg-white border border-gray-100 rounded-2xl p-5">
//             <p className="text-xs font-semibold text-amber-600 tracking-wide mb-2">
//               BEST PRICE
//             </p>
//             <p className="font-semibold text-gray-900">{highlights.bestPrice.vendor}</p>
//             <p className="text-lg font-extrabold text-gray-900 mt-1">
//               {money(highlights.bestPrice.total)}
//             </p>
//           </div>
//           <div className="bg-white border border-gray-100 rounded-2xl p-5">
//             <p className="text-xs font-semibold text-blue-600 tracking-wide mb-2">
//               FASTEST DELIVERY
//             </p>
//             <p className="font-semibold text-gray-900">{highlights.fastest.vendor}</p>
//             <p className="text-lg font-extrabold text-gray-900 mt-1">
//               {highlights.fastest.delivery} days
//             </p>
//           </div>
//           <div className="bg-white border border-gray-100 rounded-2xl p-5">
//             <p className="text-xs font-semibold text-emerald-600 tracking-wide mb-2">
//               BEST OVERALL MATCH
//             </p>
//             <p className="font-semibold text-gray-900">{highlights.bestMatch.vendor}</p>
//             <p className="text-lg font-extrabold text-gray-900 mt-1">
//               {highlights.bestMatch.rating}★ · {highlights.bestMatch.delivery}d
//             </p>
//           </div>
//         </div>
//       )}

//       <p className="text-sm text-gray-400 mb-4">
//         The system highlights strong candidates but the final decision is yours.
//       </p>

//       {/* Filters */}
//       <div className="flex flex-wrap gap-2 mb-6">
//         {filterOptions.map((f) => {
//           const isActive = filter === f;
//           return (
//             <button
//               key={f}
//               type="button"
//               onClick={() => setFilter(f)}
//               className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
//                 isActive
//                   ? "bg-indigo-600 border-indigo-600 text-white"
//                   : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//               }`}
//             >
//               {f}
//             </button>
//           );
//         })}
//       </div>

//       {/* Vendor cards */}
//       {filteredQuotes.length > 0 ? (
//         <div className="space-y-5">
//           {filteredQuotes.map((quote) => (
//             <VendorQuoteCard
//               key={quote.id}
//               quote={quote}
//               badges={badgesFor(quote)}
//               isComparing={comparing.includes(quote.id)}
//               onCompareToggle={() => toggleCompare(quote.id)}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//           No quotations match this filter yet.
//         </div>
//       )}
//     </div>
//   );
// }





import { useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Info, Trophy, Zap } from "lucide-react";
import quotationsData from "../data/quotationsData";
import StatusStepper from "../components/modules/quotations/StatusStepper";
import VendorQuoteCard from "../components/modules/quotations/VendorQuoteCard";

function money(n) {
  return `₹${n.toLocaleString("en-IN")}`;
}

const statusStyles = {
  Draft: "bg-gray-50 text-gray-600 border-gray-200",
  Published: "bg-blue-50 text-blue-700 border-blue-200",
  "Quotations Received": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Under Evaluation": "bg-amber-50 text-amber-700 border-amber-200",
  "Quotation Selected": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Work Order Initiated": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "In Development": "bg-emerald-50 text-emerald-700 border-emerald-200",
  Completed: "bg-gray-50 text-gray-600 border-gray-200",
};

const filterOptions = ["All", "Lowest Price", "Fastest Delivery", "Best Rated", "Verified only"];

export default function QuotationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [filter, setFilter] = useState("All");
  const [comparing, setComparing] = useState([]);

  const enquiry = quotationsData.find((q) => q.id === id);

  const highlights = useMemo(() => {
    if (!enquiry || enquiry.quotes.length === 0) return null;
    const bestPrice = [...enquiry.quotes].sort((a, b) => a.total - b.total)[0];
    const fastest = [...enquiry.quotes].sort((a, b) => a.delivery - b.delivery)[0];
    const bestMatch = [...enquiry.quotes].sort((a, b) => b.rating - a.rating)[0];
    return { bestPrice, fastest, bestMatch };
  }, [enquiry]);

  const filteredQuotes = useMemo(() => {
    if (!enquiry) return [];
    const quotes = [...enquiry.quotes];
    switch (filter) {
      case "Lowest Price":
        return quotes.sort((a, b) => a.total - b.total);
      case "Fastest Delivery":
        return quotes.sort((a, b) => a.delivery - b.delivery);
      case "Best Rated":
        return quotes.sort((a, b) => b.rating - a.rating);
      case "Verified only":
        return quotes.filter((q) => q.verified);
      default:
        return quotes;
    }
  }, [enquiry, filter]);

  const badgeFor = (quote) => {
    if (!highlights) return null;
    if (quote.id === highlights.bestPrice.id) return "Best Price";
    if (quote.id === highlights.fastest.id) return "Fastest";
    if (quote.id === highlights.bestMatch.id) return "Best Match";
    return null;
  };

  const toggleCompare = (quoteId) => {
    setComparing((prev) =>
      prev.includes(quoteId) ? prev.filter((cid) => cid !== quoteId) : [...prev, quoteId]
    );
  };

  if (!enquiry) {
    return (
      <div className="h-40 flex items-center justify-center text-gray-400">
        Enquiry not found.
      </div>
    );
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => navigate("/app/quotations")}
        className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-4"
      >
        <ArrowLeft className="w-4 h-4" />
        Back
      </button>

      <h1 className="text-3xl font-extrabold text-gray-900">{enquiry.title}</h1>
      <p className="text-gray-500 mt-1 mb-5">
        {enquiry.id} · {enquiry.quotes.length} quotations received
      </p>

      {/* Enquiry summary card */}
      <div className="bg-white border border-gray-100 rounded-2xl p-5 mb-6">
        <div className="flex items-start justify-between gap-4 mb-3">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-mono px-2.5 py-1 rounded-lg bg-gray-50 border border-gray-200 text-gray-600">
              {enquiry.id}
            </span>
            <span
              className={`text-xs font-medium px-2.5 py-1 rounded-lg border ${
                statusStyles[enquiry.status] || "bg-gray-50 text-gray-600 border-gray-200"
              }`}
            >
              {enquiry.status}
            </span>
          </div>
          <p className="hidden sm:flex items-start gap-1.5 text-xs text-indigo-400 max-w-[260px] text-right">
            <Info className="w-3.5 h-3.5 shrink-0 mt-0.5" />
            The system highlights strong candidates but the final decision is yours.
          </p>
        </div>

        <h2 className="font-bold text-gray-900 mb-1">{enquiry.title}</h2>
        <p className="text-sm text-gray-500 mb-4">{enquiry.description}</p>

        <div className="flex flex-wrap gap-2 mb-5">
          <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
            {enquiry.category}
          </span>
          <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
            {enquiry.industry}
          </span>
          <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
            Qty {enquiry.qty}
          </span>
          <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
            {money(enquiry.budgetMin)} – {money(enquiry.budgetMax)}
          </span>
          <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
            Target {enquiry.targetDate}
          </span>
        </div>

        <StatusStepper status={enquiry.status} />
      </div>

      {/* Highlight banners */}
      {highlights && (
        <div className="grid sm:grid-cols-3 gap-4 mb-6">
          <div className="rounded-2xl p-4 text-white bg-gradient-to-r from-sky-400 to-blue-600">
            <p className="flex items-center gap-1.5 text-xs font-semibold tracking-wide opacity-90 mb-2">
              <Trophy className="w-3.5 h-3.5" />
              BEST PRICE
            </p>
            <p className="font-semibold text-sm">{highlights.bestPrice.vendor}</p>
            <p className="text-lg font-extrabold mt-0.5">{money(highlights.bestPrice.total)}</p>
          </div>
          <div className="rounded-2xl p-4 text-white bg-gradient-to-r from-purple-500 to-fuchsia-600">
            <p className="flex items-center gap-1.5 text-xs font-semibold tracking-wide opacity-90 mb-2">
              <Zap className="w-3.5 h-3.5" />
              FASTEST DELIVERY
            </p>
            <p className="font-semibold text-sm">{highlights.fastest.vendor}</p>
            <p className="text-lg font-extrabold mt-0.5">{highlights.fastest.delivery} days</p>
          </div>
          <div className="rounded-2xl p-4 text-white bg-gradient-to-r from-orange-400 to-pink-500">
            <p className="flex items-center gap-1.5 text-xs font-semibold tracking-wide opacity-90 mb-2">
              <Trophy className="w-3.5 h-3.5" />
              BEST OVERALL MATCH
            </p>
            <p className="font-semibold text-sm">{highlights.bestMatch.vendor}</p>
            <p className="text-lg font-extrabold mt-0.5">
              {highlights.bestMatch.rating}★ · {highlights.bestMatch.delivery}d
            </p>
          </div>
        </div>
      )}

      {/* Filters */}
      <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6 flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-gray-500 mr-1">Filter:</span>
        {filterOptions.map((f) => {
          const isActive = filter === f;
          return (
            <button
              key={f}
              type="button"
              onClick={() => setFilter(f)}
              className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                isActive
                  ? "bg-indigo-600 border-indigo-600 text-white"
                  : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
              }`}
            >
              {f}
            </button>
          );
        })}
      </div>

      {/* Vendor cards */}
      {filteredQuotes.length > 0 ? (
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-5">
          {filteredQuotes.map((quote, index) => (
            <VendorQuoteCard
              key={quote.id}
              quote={quote}
              badge={badgeFor(quote)}
              avatarIndex={index}
              isComparing={comparing.includes(quote.id)}
              onCompareToggle={() => toggleCompare(quote.id)}
            />
          ))}
        </div>
      ) : (
        <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No quotations match this filter yet.
        </div>
      )}
    </div>
  );
}